import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import _ from 'lodash';
import { filtersConfig } from './utils';

const api = bindServices('connectionGroup');
const namespace = 'connectionGroup';

const ConnectionsGroupsModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
  },
  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'connectionGroup',
      fetchParams: 'connectionGroup',
    }),

    *saveNewItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: { success: false } });
        yield call(api.create, {
          route: 'connectionGroup',
          data: payload,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        yield put({
          type: 'success',
          payload: { success: true },
        });

        yield put({
          type: 'fetchList',
          payload: { page: 1, limit: 10 },
        });
      } catch (error) {
        if (error?.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });

          yield put({
            type: 'errors',
            payload: {
              validationErrors: error.validationErrors || [],
              message: error.message,
            },
          });
        }
      }
    },

    *saveEditItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: { success: false } });
        yield call(api.update, {
          route: 'connectionGroup',
          id: payload.id,
          data: payload,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });

        yield put({
          type: 'success',
          payload: { success: true },
        });

        yield put({
          type: 'fetchList',
          payload: { page: 1, limit: 10 },
        });
      } catch (error) {
        if (error?.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });

          yield put({
            type: 'errors',
            payload: {
              validationErrors: error.validationErrors || [],
              message: error.message,
            },
          });
        }
      }
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState,
    }),
    // keeping reducer hook available in case filters need to be updated dynamically
    filterConfig(state, { payload }) {
      return { ...state, filtersConfig: payload };
    },
    setView(state, { payload }) {
      return {
        ...state,
        view: payload.view,
      };
    },
  },
};

export default ConnectionsGroupsModel;
